<template>
  <div class="middle cadfm-flexitem-stretched">

    <action-panel>
      <action-bar>
        <b-navbar-nav>
          <!-- <action-button v-if="isPlugin||isAgent" @click="checkLocalLibrary" icon="open" bold :text="lang.button_Open"
            :title="lang.button_Open" :disabled="openButtonStatus" />
          <action-button v-if="isPlugin||isAgent" @click="push" icon="import" bold :text="lang.button_Push"
            :title="lang.button_Push" :disabled="pushButtonStatus" /> -->
          <action-button @click="_new" icon="new" bold :text="lang.button_New" :title="lang.button_New"
            :disabled="newButtonStatus" />
          <action-button @click="details" icon="details-part" bold :text="lang.button_Details"
            :title="lang.button_Details" :disabled="detailsButtonStatus" />

          <action-button @click="derive" icon="derive" bold :text="lang.button_Derive" :title="lang.button_Derive" :disabled="deriveButtonStatus" />
          <action-button v-if="currentUser.role=='Admin' && globalSettings.deletionOfElements" @click="_delete" icon="remove" bold :text="lang.button_Delete"
            :title="lang.button_Delete" :disabled="deleteButtonStatus" />
          <action-button @click="removeRevision" icon="remove" bold :text="lang.button_RemoveRevision"
            :title="lang.button_RemoveRevision" :disabled="removeRevisionButtonStatus" />
          <action-button @click="withdraw" icon="withdraw" bold :text="lang.button_Withdraw"
            :title="lang.button_Withdraw" :disabled="withdrawButtonStatus" />
          <action-button v-if="currentUser.role=='Admin'" @click="moveTo" icon="move-to" bold :text="lang.button_MoveTo" :title="lang.button_MoveTo" :disabled="moveToButtonStatus" />
          <!-- <action-button v-if="!isPlugin"  @click="pull"  icon="download" bold :text="lang.button_Pull"
            :title="lang.button_Pull" :disabled="pullButtonStatus"/>
          <action-button v-if="!isPlugin"  @click="push"  icon="import" bold :text="lang.button_Push"
            :title="lang.button_Push" :disabled="pushButtonStatus"/> -->
          <action-button v-if="(currentUser.role=='Admin')" @click="properties" icon="properties" bold
            :text="lang.button_Properties" :title="lang.button_Properties" :disabled="propertiesButtonStatus" />
          <action-button v-if="!isPlugin" @click="offline" icon="download" bold :text="lang.button_DownloadZIP"
            :title="lang.button_DownloadZIP" :disabled="downloadZIPButtonStatus" />
          <action-button v-if="isPlugin" @click="testConcat" icon="download" bold :text="lang.button_DownloadZIP"
            :title="lang.button_DownloadZIP" />



        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <action-button v-show="!$parent.isVisibleLeft" @click="toggleLeftPanel" icon="show" bold
            :text="lang.button_Left" :title="lang.button_Left" :disabled="toggleButtonStatus" />
          <action-button v-show="!$parent.isVisibleRight" @click="toggleRightPanel" icon="show" bold
            :text="lang.button_Right" :title="lang.button_Right" :disabled="toggleButtonStatus" />

        </b-navbar-nav>

      </action-bar>

      <action-content>
        <Content  :lang="lang.Content"></Content>
      </action-content>
    </action-panel>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LibraryTypes from '@/constants/LibraryTypes'
import ActionBar from '@/components/shared/ActionBar'
import ActionButton from '@/components/shared/ActionButton'
import ActionContent from '@/components/shared/ActionContent'
import ActionPanel from '@/components/shared/ActionPanel'
import TitleComponent from "@/components/shared/TitleComponent"
import Content from "@/components/LibraryManager/Views/LibraryTable/Middle/Content/Content"
//import * as Json2Svg from '@/Tools/json2svg';
import * as Tools from '@/Tools/Tools'

export default {
  name: 'Middle',
  components: {
    ActionBar,
    ActionButton,
    ActionContent,
    ActionPanel,
    TitleComponent,
    Content
  },
  props:{
    lang: Object
  },
  data () {
    return {
      
      detailsButtonStatus: true,
      deriveButtonStatus: true,
      deleteButtonStatus: true,
      removeRevisionButtonStatus: true,
      newButtonStatus: false,
      withdrawButtonStatus: true,
      openButtonStatus: true,
      pushButtonStatus: true,
      moveToButtonStatus: true,
      propertiesButtonStatus: false,
      downloadZIPButtonStatus: false,
      toggleButtonStatus: false,

      lockedRevisionId: ""
    }
  },
  created(){
    
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      selectedRows: 'selectedRows',
      isPlugin: 'isPlugin',
      isAgent: 'isAgent',
      appConf: 'appConf',
      isSecondLevel: 'isSecondLevel',
      globalSettings: "globalSettings"
    }),
    
  },
  watch: {
    selectedRows: function (new_isData, old_isData) {
      //for details button
      if (this.selectedRows.length == 1){
        this.detailsButtonStatus = false

      }else{
         this.detailsButtonStatus = true
      }
      //for withdraw button
      if (this.selectedRows.length > 0){
        this.withdrawButtonStatus = false

      }else{
         this.withdrawButtonStatus = true
      }
      if (this.selectedRows.length > 0){
        this.openButtonStatus = false

      }else{
         this.openButtonStatus = true
      }
      if (this.selectedRows.length > 0 ){//&& !isSecondLevel
        this.pushButtonStatus = false

      }else{
         this.pushButtonStatus = true
      }
      // if (this.selectedRows.length > 0){
      //   this.downloadZIPButtonStatus = false

      // }else{
      //    this.downloadZIPButtonStatus = true
      // }
      //for derive button
      if (this.selectedRows.length == 1){
        this.deriveButtonStatus = false

      }else{
         this.deriveButtonStatus = true
      }
      //for delete button
      if (this.selectedRows.length == 1){
        this.deleteButtonStatus = false

      }else{
         this.deleteButtonStatus = true
      }
      //for removeRevision button
      
      if (this.selectedRows.length == 1) {
        
        if (this.selectedRows[0].col___revisionId.requestorUserId == this.currentUser.userId && this.selectedRows[0].col___status.value.display == "pending") {
          
          this.removeRevisionButtonStatus = false;
        } else {
          
          this.removeRevisionButtonStatus = true
        }

      } else {
        
        this.removeRevisionButtonStatus = true
      }
      //for move button
      if (this.selectedRows.length == 1) {
        this.moveToButtonStatus = false

      } else {
        this.moveToButtonStatus = true
      }
      
      


    },
    
  },
  methods: {
    
    details(){
      let to = "/LibraryManager/LibraryDetails";

      this.$store.dispatch("editPropertiesForm", false);

      let revisionId = 0;
      let id = 0;
      if (this.$store.getters.selectedRows != undefined){
        revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        id = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
      }

      

      
      const query = {
        from: this.$route.path,
        to: to,
        revisionId: revisionId,
        id: id
      }

      this.$router.push({ path: to, query: query }); 
    },
    _new() {

      let to = "/LibraryManager/LibraryNew";
      
      

      
      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query }); 
    },
    derive() {

      let to = "/LibraryManager/LibraryDerive";
      let revisionId = 0;
      let id = 0;
      if (this.$store.getters.selectedRows != undefined) {
        revisionId = this.$store.getters.selectedRows[0].col___revisionId.revisionId;
        id = this.$store.getters.selectedRows[0].col___revisionId.libraryId;
      }
      
      const query = {
        from: this.$route.path,
        to: to,
        source: "LibraryTable",
        revisionId: revisionId,
        id: id
      }

      this.$router.push({ path: to, query: query }); 
      
    },
    withdraw(){

      
      let alert_success_withdraw = this.lang.alert_success_withdraw;
      let alert_error_withdraw = this.lang.alert_error_withdraw;

      let withdrawLibraries = function(_vue){
        const arr = [];

                
        for (var i = 0, le = _vue.$store.getters.selectedRows.length; i < le; i++){
          arr.push(_vue.$store.getters.selectedRows[i].col___revisionId.libraryId)

        }
        
        const obj = {
          libraryIds: arr 
        }
        
        _vue.$store.dispatch(_vue.$store.getters.sectionPrefix+"_setWithdraw", obj)
        .then((result) => {
          
          console.log(result)
          if (result.status == "OK"){

            if (result.data == 1){
              let obj = {
                text: alert_success_withdraw,
                time: 5,
                type: "success"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);

              const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiLibComponent"
              }
              _vue.$store.dispatch("reloadAfterAction", reloadObj);

            }else{
              let obj = {
                text: alert_error_withdraw + ": " + result.message,
                time: 10,
                type: "danger"
              }

              _vue.$store.dispatch("displayFooterAlert", obj);
            }
     
          }else{
            let obj = {
              text: alert_error_withdraw + ": " + result.message,
              time: 10,
              type: "danger"
            }

            _vue.$store.dispatch("displayFooterAlert", obj);

          }
        })

      }
            
      const obj = {
        title: "Withdraw",
        text: this.lang.alert_withdraw,
        type: "withdraw",
        buttons: 2,
        size: "sm",
        funcYes: withdrawLibraries,
        funcNo: "",

      }
 
      this.$store.dispatch("showAlert", obj);


    },
    checkLocalLibrary(){
      let vue = this;
      
      this.lockedRevisionId = this.$store.getters.selectedRows[0];

      const obj = {
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        type:this.$store.getters.selectedRows[0].col___libraryType.value.display,
        name:this.$store.getters.selectedRows[0].col___name.value.display,
        category:this.$store.getters.selectedRows[0].col___revisionId.category
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_checkLibrary", obj)
      .then((result) => {
        console.log(result);
        if (result.status == "OK"){

          let files = result.data.localFiles;
          let path = result.data.localPath;

          if (files.length > 0){
            let funcYes = function(){
              
              
            
              vue.open();
           
            }

            const obj = {
              title: vue.lang.alert_title_openLibrary,
              text: vue.lang.alert_openLibrary_1 + " (" + path + "). " + vue.lang.alert_openLibrary_2,
              type: "question",
              buttons: 2,
              size: "lm",
              funcYes: funcYes,
              funcNo: "",

            }
    
            vue.$store.dispatch("showAlert", obj);
          }else{
            vue.open();
          }
        
        }else{

          let obj = {
            text: vue.lang.alert_error_CheckLibrary + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }
        
      })
        

    },
    open(){

      let vue = this;
      this.$store.dispatch("showLoader", {visible: true, text: "open"});
      
      this.lockedRevisionId = this.$store.getters.selectedRows[0];

      const obj = {
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        type:this.$store.getters.selectedRows[0].col___libraryType.value.display,
        name:this.$store.getters.selectedRows[0].col___name.value.display,
        category:this.$store.getters.selectedRows[0].col___revisionId.category
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_openLibrary", obj)
      .then((result) => {
         vue.$store.dispatch("showLoader", {visible: false});
        console.log(result);

        if (result.status == "OK"){
          let obj = {
            text: "",
            time: 10,
            type: "success"
          }
                  
          if (result.data.openLibraryResult == null){
            // obj = {
            //   text: "Error",
            //   time: 15,
            //   type: "danger"
            // }
            // vue.$store.dispatch("displayFooterAlert", obj);
            return
          }


          
          if (result.data.openLibraryResult.status == "OK"){
            obj = {
              text: vue.lang.alert_success_OpenLibrary + " " + result.data.openLibraryResult.data,
              time: 10,
              type: "success"
            }
            
          }else{
            obj = {
              text: vue.lang.alert_error_OpenLibrary + result.data.openLibraryResult.message,
              time: 15,
              type: "danger"
            }
          }
          
          vue.$store.dispatch("displayFooterAlert", obj);

        }else{
          let obj = {
            text: vue.lang.alert_error_OpenLibrary + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);
        }

       
      })
      
    },
    testConcat(){
      let vue = this;
      this.$store.dispatch("showLoader", {visible: true, text: "open"});
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_trySyncSchematicLibrary")
      .then((result) => {
        vue.$store.dispatch("showLoader", {visible: false});
        console.log(result);


      });
    },
    push(){

      let vue = this;
      this.$store.dispatch("showLoader", {visible: true, text: "push"});

      //this.pushImage();

      this.lockedRevisionId = this.$store.getters.selectedRows[0];
      

      const obj = {
        revisionId: this.$store.getters.selectedRows[0].col___revisionId.revisionId,
        type:this.$store.getters.selectedRows[0].col___libraryType.value.display,
        name:this.$store.getters.selectedRows[0].col___name.value.display,
        category:this.$store.getters.selectedRows[0].col___revisionId.category
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_pushLibrary", obj)
      .then((result) => {


        console.log(result);
                

        if (result.status == "OK"){
          result.data.lockedRevisionId = vue.lockedRevisionId.col___revisionId.revisionId;

          let func = function(){
            
            if (result.data.newRevisionId == null){
             
            }else{
              
              vue.goTo();
            }
            
          }
          vue.$store.dispatch("showLoader", {visible: false});
          const obj = {
            title: vue.lang.modal_title_PushLibrary,
            text: "",
            type: "push_files",
            buttons: 1,
            buttonName: "Close",
            size: "xl",
            lang: vue.lang.modal_PushLibrary,
            funcNo: "",
            funcYes: "",
            funcCustom: func,
            data: result.data
          };
          vue.$store.dispatch("showModalComponent", obj);
          
        }else{

          let obj = {
            text: vue.lang.alert_error_PushLibrary + ": " + result.message,
            time: 15,
            type: "danger"
          }

          vue.$store.dispatch("displayFooterAlert", obj);

        }

        
      })
      
    },
    goTo(){

            
      let to = "/LibraryManager/LibraryDetails";

      const obj = {
        col___revisionId: {
          revisionId: this.lockedRevisionId.col___revisionId.revisionId,
          libraryId: this.lockedRevisionId.col___revisionId.libraryId
        },
        col___revision: {
          revisionId: this.lockedRevisionId.col___revision.value.display
          
        },
        col___status: {
          
        },
        col___image: {
         
        },
        col___name: {
         
        }
      }
      
   
      this.$store.dispatch("setSelectedRows", obj);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);

      

      

      const query = {
        from: this.$route.path,
        to: to,
        pushed: true,
        revisionId: this.lockedRevisionId.col___revisionId.revisionId
      }

      this.$router.push({ path: to, query: query });
      
    },
    properties() {

      let to = "/LibraryManager/Properties";
      
      

      

      const query = {
        from: this.$route.path,
        to: to,
        
      }

      this.$router.push({ path: to, query: query });
    },
    offline(){
      
      this.$store.dispatch("showLoader", {visible: true, text: "download"});
      let vue = this;
      let activeActions = [];
      for (let i = 0, lei = this.$store.getters.lm_activeActions.length; i < lei; i++){
        const obj = {
          actionId: this.$store.getters.lm_activeActions[i].actionId
        }
        activeActions.push(obj);
      }

      let obj = {
        categoryId: this.$store.getters.selectedTreeLibraryItemObject.categoryId,
        actions: activeActions
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + "_getActiveLibraries", obj)
      .then((result) =>{

          vue.$store.dispatch("showLoader", {visible: false});
          console.log(result)
          let fileName = "LIBRARIES.ZIP";

          var a = document.createElement("a");
          a.href = URL.createObjectURL(result);
          a.download = fileName;
          
          document.body.appendChild(a);
          
          a.click();
          document.body.removeChild(a);
      })
      .then(function() {
        
        vue.$store.dispatch("showLoader", {visible: false});
        
      })

    },
    // pushImage(){
      
     
    //   let elements = this.$store.getters.selectedRows[0].col___name.value.display;
    //   let libraryType = this.$store.getters.selectedRows[0].col___libraryType.value.display

    //   if ((libraryType != LibraryTypes.PART || libraryType != LibraryTypes.SYMBOL) && (libraryType != LibraryTypes.FOOTPRINT) && (libraryType != LibraryTypes.MECHANICAL)){

    //     return
    //   }
     
    //   this.lockedRevisionId = this.$store.getters.selectedRows[0];
    //   this.generateSVG(elements, libraryType);

    // },
    // generateSVG(elements, type){
    //   var _vue = this;
    //   this.$store.dispatch("showLoader", {visible: true, text: "wait"});
    //   const elementsArray = elements.split(",");

            
    //   for (let i = 0, lei = elementsArray.length; i < lei; i++){

                

    //     this.generateLocalSvg(elementsArray[i], type)
    //     .then(function(resp){
    //       let svgStr = resp.svg;
          
    //         const blob = new Blob([svgStr], {type: 'image/svg+xml'});
    //         const file = new File([blob], resp.actualName+'.svg')
    //         //send to api
            
    //         if (_vue.appConf.status.isLM===true){

    //           const obj = {
    //             revisionId: _vue.lockedRevisionId.col___revisionId.revisionId,
    //             file: file,
    //             lastModified: Tools.IntegerToIntegerUTC(file.lastModified),
    //             //lastModified: file.lastModified,
    //             //fileName: file.name
    //           }

              
              
    //           return _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_importFiles", obj)
    //             .then((result)=>{
                  
    //               //result = JSON.parse(result);
    //               console.log(result);
                  
 
    //               if (result.data.result == "identical"){
    //                 console.log("The files are identical")
    //               }
    //               if (result.data.result == "excluded"){
    //                 console.log("File type unable to load")
    //               }
    //               if (result.data.result == "added"){
    //                 console.log("The file was added correctly")
    //               }
    //               if (result.data.result == "updated"){
    //                 console.log("The file has been correctly updated")
    //               }
    //               let obj = {};
    //               if (result.data != undefined){
    //                 if (result.data == 1){
    //                   obj = {
    //                     text: _vue.lang.alert_success_create_image,
    //                     time: 10,
    //                     type: "success"
    //                   }
    //                 }else{
    //                   obj = {
    //                     text: _vue.lang.alert_error_create_image,
    //                     time: 15,
    //                     type: "danger"
    //                   }
    //                 }
    //               }else{
                    
    //                 let err = "";
    //                 if (result.message != undefined){
    //                   err = ": " + result.message;
    //                 }
    //                 obj = {
    //                   text: _vue.lang.alert_error_create_image + err,
    //                   time: 15,
    //                   type: "danger"
    //                 }
    //               }
    //               _vue.$store.dispatch("displayFooterAlert", obj);
                  
                  
                  
    //             });
    //         } else {
    //           const objFile = {
    //             type: type, //type of library
    //             file: file //file name is a name of library
    //           };

    //           return _vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_uploadSvg", objFile)
    //               .then((result)=>{
    //                 result = JSON.parse(result);
    //                     console.log(result);
                        
    //                     let obj = {};
    //                     if (result.data != undefined){
    //                       if (result.data == 1){
    //                         obj = {
    //                           text: _vue.lang.alert_success_create_image,
    //                           time: 10,
    //                           type: "success"
    //                         }
    //                       }else{
    //                         obj = {
    //                           text: _vue.lang.alert_error_create_image,
    //                           time: 15,
    //                           type: "danger"
    //                         }
    //                       }
    //                     }else{
                          
    //                       let err = "";
    //                       if (result.message != undefined){
    //                         err = ": " + result.message;
    //                       }
    //                       obj = {
    //                         text: _vue.lang.alert_error_create_image + err,
    //                         time: 15,
    //                         type: "danger"
    //                       }
    //                     }
    //                     _vue.$store.dispatch("displayFooterAlert", obj);
    //               });
    //         }
            
    //     })

        


        

        

    //   }

      
    // },
    // generateLocalSvg(element, type) {
    //     let vue = this;
        
        
    //     if (type == LibraryTypes.PART || type == LibraryTypes.SYMBOL){
    //       //console.log("calling makeSymbolSVG("+element+","+type+")");
    //       return tclAPI.makeSymbolSVG(element,type)
    //         .then(function (resp) {
              
              
    //           let errorsList = JSON.parse(resp.errors);
    //           if (resp.json == "") {

                

    //             return $.Deferred().reject(errorsList).promise();
    //           }
    //           let jsonString = JSON.parse(resp.json);
              
    //           var svgStr = Json2Svg.create(jsonString, 400, 400);
              
    //           return $.Deferred().resolve({svg:svgStr, actualName:resp.actualName}).promise();
    //         })
    //         .then(null, function (err) {
              
    //           console.warn(err);
    //             let obj = {
    //               text: "alert_error_create_image: " + err,
    //               time: 15,
    //               type: "danger"
    //             }

    //             vue.$store.dispatch("displayFooterAlert", obj);
                

    //             return $.Deferred().reject(err).promise();
    //         })
    //         .always(function() {
    //           vue.$store.dispatch("showLoader", {visible: false});
              
    //         });
    //     }
    //   if (type == LibraryTypes.FOOTPRINT || type == LibraryTypes.MECHANICAL){
    //       return tclAPI.makeFootprintSVG(element,type)
    //         .then(function (resp) {
              
    //           let errorsList = JSON.parse(resp.errors);
    //           console.log(resp);
              
    //           if (resp.svg == "") {
    //             return $.Deferred().reject(errorsList).promise();
    //           }
    //           //let jsonString = JSON.parse(resp.svg);
              
    //           //var svgStr = Json2Svg.create(jsonString, 400, 400);
    //           return $.Deferred().resolve({svg:resp.svg, json:resp.json, actualName:resp.actualName}).promise();
    //         })
    //         .then(null, function (err) {
              
              
    //           console.warn(err);
    //           let obj = {
    //             text: "alert_error_create_image: " + err,
    //             time: 15,
    //             type: "danger"
    //           }

    //           vue.$store.dispatch("displayFooterAlert", obj);
              

    //           return $.Deferred().reject(err).promise();
    //         })
    //         .always(function() {
    //           vue.$store.dispatch("showLoader", {visible: false});
              
    //         });
    //     }
        

    // },
    _delete(){
      
      let vue = this;

      let deleteProjectFunc = function(){
        const obj = {
          libraryId: vue.$store.getters.selectedRows[0].col___revisionId.libraryId
        }

        vue.$store.dispatch( vue.$store.getters.sectionPrefix + "_deleteLibrary", obj)
        .then((result) =>{

          console.log(result)
          let obj = {};
          if (result.status == "OK"){

            if (result.data != null){
              obj = {
                text: vue.lang.alert_success_delete_library,
                time: 10,
                type: "success"
              }

              const reloadObj = {
                    status: true,
                    name: "DataTableFilteredOnApiLibComponent"
                }
                vue.$store.dispatch("reloadAfterAction", reloadObj);

            }else{
              obj = {
                text: vue.lang.alert_error_delete_library + ".",
                time: 15,
                type: "danger"
              }

            }
          }else{
            obj = {
              text: vue.lang.alert_error_delete_library + ": " + result.message,
              time: 15,
              type: "danger"
            }

          }
          vue.$store.dispatch("displayFooterAlert", obj);
        })
      }

      const obj = {
        title: vue.lang.modal_title_delete,
        text: vue.lang.alert_delete,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: deleteProjectFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
      
    },
    removeRevision() {
      let vue = this;

      let removeFunc = function () {
        const obj = {
          libraryRevisionId: vue.$store.getters.selectedRows[0].col___revisionId.revisionId
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_removeRevision", obj)
          .then((result) => {

            console.log(result)
            let obj = {};
            if (result.status == "OK") {

              if (result.data != null) {
                obj = {
                  text: vue.lang.alert_success_removeRevision_library,
                  time: 10,
                  type: "success"
                }

                const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiLibComponent"
                }
                vue.$store.dispatch("reloadAfterAction", reloadObj);

              } else {
                obj = {
                  text: vue.lang.alert_error_removeRevision_library + ".",
                  time: 15,
                  type: "danger"
                }

              }
            } else {
              obj = {
                text: vue.lang.alert_error_removeRevision_library + ": " + result.message,
                time: 15,
                type: "danger"
              }

            }
            vue.$store.dispatch("displayFooterAlert", obj);
          })
      }

      const obj = {
        title: vue.lang.modal_title_removeRevision,
        text: vue.lang.alert_removeRevision,
        type: "sure",
        buttons: 2,
        size: "sm",
        funcYes: removeFunc,
        funcNo: ""
      };

      this.$store.dispatch("showAlert", obj);
    },
    moveTo() {


      let vue = this;


      let funcYes = function (e) {

        let newMovingCategory = vue.$store.getters.newMovingCategory;


        let obj = {
          libraryId: newMovingCategory.libraryId,
          categoryId: newMovingCategory.categoryId
        }

        vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_moveToAnotherCategory", obj)
          .then(function (result) {

            console.log(result)

            if (result.status == "OK") {



              if (result.data != null) {

                let obj = {
                  text: vue.lang.alert_success_MoveLibrary,
                  time: 10,
                  type: "success"
                };

                vue.$store.dispatch("displayFooterAlert", obj);


                //reload table
                const reloadObj = {
                  status: true,
                  name: "DataTableFilteredOnApiLibComponent"
                }
                vue.$store.dispatch("reloadAfterAction", reloadObj);
              } else {
                let obj = {
                  text: vue.lang.alert_error_MoveLibrary,
                  time: 15,
                  type: "danger"
                };

                vue.$store.dispatch("displayFooterAlert", obj);
              }

            } else {
              let obj = {
                text: vue.lang.alert_error_MoveLibrary,
                time: 15,
                type: "danger"
              };

              vue.$store.dispatch("displayFooterAlert", obj);
            }


          })

      }

      var obj = {

        text: "",
        type: "moving",
        buttons: 2,
        size: "lg",
        lang: this.lang.modal_Moving,
        funcNo: "",
        funcYes: funcYes
      };
      this.$store.dispatch("showModalComponent", obj);



    },
    toggleRightPanel(){
      
      this.$parent.isVisibleRight = !this.$parent.isVisibleRight;
      
    },
    toggleLeftPanel(){
      
      this.$parent.isVisibleLeft = !this.$parent.isVisibleLeft;
      
    }


  },
  
}
</script>


<style scoped>

  .middle{
    border-right: 1px solid #666;
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/LibraryManager/Views/LibraryTable/Middle/Middle.vue